<div 
  *ngIf="(authService.isLoggedIn$ | async), else loginTemplate" 
  [ngClass]="{ 'hidden': (legacyService.legacyLoading$ | async) }" 
  class="scs-container">

  <ng-container *ngIf="!(globalsService.initialLoading$ | async), else initialLoadingTemplate">

    <ng-container *ngIf="isUserSubsciptionActive, else subsciptionInactiveTemplate">

      <scs-header></scs-header>

      <div class="content-wrapper">  
        <scs-references *ngIf="(globalsService.currentTab$ | async) === 0"></scs-references>
        <scs-bibliography *ngIf="(globalsService.currentTab$ | async) === 1"></scs-bibliography>
        <scs-options *ngIf="(globalsService.currentTab$ | async) === 2"></scs-options>
      </div>

    </ng-container>
  
    <ng-template #subsciptionInactiveTemplate>
      <scs-subscription></scs-subscription>
    </ng-template>

  </ng-container>

</div>

<scs-item-panel 
  *ngIf="(itemsDisplayService.itemPanelVisible$ | async)"
  class="panel scrollbar">
</scs-item-panel>

<scs-override-panel 
  *ngIf="(citationsQueueService.overridePanelVisible$ | async)"
  class="panel scrollbar">
</scs-override-panel>

<scs-options-panel 
  *ngIf="(itemsDisplayService.optionsPanelVisible$ | async)"
  class="panel panel--sm scrollbar">
</scs-options-panel>

<ng-template #initialLoadingTemplate>
  <div class="loader_overlay">
    <scs-loader class="center-horizontal-vertical"></scs-loader>
  </div>
</ng-template>

<div *ngIf="legacyService.legacyLoading$ | async" class="loader_overlay">
  <scs-loader class="center-horizontal-vertical">
    <div><small>Updating citations...</small></div>
  </scs-loader>
</div>

<ng-template #loginTemplate>
  <scs-login></scs-login>
</ng-template>

<scs-toast></scs-toast>

<scs-svg-icon-definitions></scs-svg-icon-definitions>
